import React from 'react';
import { ContentWrapper, ContentCard } from '../../common/components/ContentCard';
import {
  Table,
  THead,
  TableRow,
  Th,
  TableWrapper,
  Td,
  H1,
  FilterButton,
  Pagination
} from '@increasecard/typed-components';
import { localizedTimestamp, LoadingOverlay } from '@card/commonlib';
import styled from 'styled-components';
import { useReportsScreen } from './useReportsScreen';
import { LoadableStatus } from '@card/types';
import { ReportActions } from './components/ReportActions';
import { ReportLastDownload } from './components/ReportLastDownload';

const Title = styled(H1)`
  margin-bottom: 16px;
`;

export function ReportsScreen() {
  const { reports, page, setPage, filterFields, filters, setFilters } = useReportsScreen();
  return (
    <ContentCard>
      <ContentWrapper>
        <Title>Reportes</Title>
        <div style={{ marginBottom: '16px' }}>
          <FilterButton fields={filterFields} onChange={setFilters} value={filters} />
        </div>
        <LoadingOverlay active={reports.status === LoadableStatus.Fetching}>
          <TableWrapper>
            <Table zebra>
              <THead>
                <TableRow>
                  <Th>Creación</Th>
                  <Th>Nombre del reporte</Th>
                  <Th>Última descarga</Th>
                  <Th rightAligned />
                </TableRow>
              </THead>
              <tbody>
                {reports.data &&
                  reports.data.data.map((report) => (
                    <TableRow key={report.id}>
                      <Td>{localizedTimestamp(new Date(report.created_at))}</Td>
                      <Td>{report.filename}</Td>
                      <Td>
                        <ReportLastDownload {...report} />
                      </Td>
                      <Td rightAligned>
                        <ReportActions {...report} />
                      </Td>
                    </TableRow>
                  ))}
              </tbody>
            </Table>
            <div style={{ paddingTop: '16px' }}>
              <Pagination
                currentPage={page}
                onSelectPage={setPage}
                style={{ justifyContent: 'flex-end' }}
                totalPages={reports.data ? reports.data.total_pages : 1}
              />
            </div>
          </TableWrapper>
        </LoadingOverlay>
      </ContentWrapper>
    </ContentCard>
  );
}
